import React from "react";

const DocumentSearchBar = ({
  value,
  onChange,
  onSearch,
}) => {

    const FIXED_SEARCH_HEADERS = [
        { pattern_name: "title", pattern_text: "タイトル", display_idx: 1 },
        { pattern_name: "u_datetime", pattern_text: "最終更新日", display_idx: 2 },
        { pattern_name: "user_name", pattern_text: "最終更新者", display_idx: 3 },
    ];

    const handleSearch = () => {
        const trimmed = value.trim(); 

        if (!trimmed) {
            onSearch("", FIXED_SEARCH_HEADERS);
            return;
        }

        onSearch(trimmed, FIXED_SEARCH_HEADERS);
    };

    return (
        // <div className="document-header__container" style={{alignItems: 'flex-end', justifyContent: 'flex-end'}}>
            <div className="document-search">
                <div className="document-search__input-wrapper" style={{display: "flex", flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end'}}>
                    <input
                        type="text"
                        className="document-search__input"
                        value={value}
                        onChange={(e) => onChange(e.target.value)}
                        onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                    />

                    <button className="document-search__button" onClick={handleSearch}>
                        <img src="/img/common/search.svg" alt=""/>
                    </button>
                </div>
            </div>
        // </div>
    );
};

export default DocumentSearchBar;
